export type ColumnDefinition = {
    name: string;
    type: string;
    required?: boolean;
};

export type FormatDefinition = {
    name: string;
    columns: Record<string, ColumnDefinition>;
};

export const jobFormats: Record<string, FormatDefinition> = {
    format1: {
        name: 'Detailed Format',
        columns: {
            title: { name: 'M1**) Job title', type: 'string', required: true },
            description: { name: 'M2**) What is this Job (Job description)', type: 'string' },
            location: { name: 'I**) Work location', type: 'string' },
            category: { name: 'M4**) Job category', type: 'string' },
            type: { name: 'M5**) Full time / part time / project & ALL', type: 'string' },
            salary: { name: 'M6**) Offered salary range', type: 'string' },
            company: { name: 'I**) Hiring Company', type: 'string' },
            aboutCompany: { name: 'I**) About Company', type: 'string' },
            requirements: { name: 'M3**) What we prefer (academic/ professional experience / projects related..)', type: 'string' },
            skills: { name: 'M3**) Coding language / IT skillset', type: 'string' },
            package: { name: 'I) What we provide (package offer)', type: 'string' },
            highlights: { name: 'I) Company highlightes / remark', type: 'string' },
            createdAt: { name: 'I**) Posted date', type: 'date format DD-MM-YYYY)\n (12-04-2025' }
        }
    },
    format2: {
        name: 'Plain Format',
        columns: {
            title: { name: 'Job Title', type: 'string', required: true },
            description: { name: 'Job Description', type: 'string' },
            location: { name: 'Work Location', type: 'string' },
            category: { name: 'Job Category', type: 'string' },
            type: { name: 'Job Type', type: 'string' },
            salary: { name: 'Salary Range', type: 'string' },
            company: { name: 'Company', type: 'string' },
            createdAt: { name: 'Posted Date', type: 'string' }
        }
    },
};

export const userFormats: Record<string, FormatDefinition> = {
    format1: {
        name: 'Detailed Format',
        columns: {
            fullName: { name: 'I**) Candidate', type: 'string', required: true },
            email: { name: 'I**) Email', type: 'email', required: true },
            gender: { name: 'I) Gender', type: 'string' },
            age: { name: 'I) Age', type: 'number' }, //?
            jobTitle: { name: 'M1) Job title', type: 'string' },
            jobDescription: { name: 'M2) Years of work experience & description', type: 'string' },
            education: { name: 'M3**) Academic & Professoinal training / Achievement', type: 'string' },
            skills: {
                name: 'M3**) Coding language / IT skillset & others',
                type: 'multiple string (one skill per line)'
            },
            workHistory: { name: 'M3) Relevant Projects/ Professional experience (quantify result)', type: 'string' }, //?
            achievement: { name: 'M3**) Project Experienced using STAR Method', type: 'string' }, //?
            description: { name: 'M3**) Personality / Unique traits / cultural fit… etc', type: 'string' },
            jobLookingFor: { name: 'M4**) Job category looking for (ALL)', type: 'string' },
            jobLookingForType: { name: 'M5**) Full time / part time / project / Intern & (ALL)', type: 'string' },
            jobLookingForSalary: { name: 'M6**) Expected salary range (Null)', type: 'number' },
            interest: { name: 'I) Interest:', type: 'string' }//?
        }
    },
    format2: {
        name: 'Plain Format',
        columns: {
            fullName: { name: 'Full Name', type: 'string', required: true },
            email: { name: 'Email', type: 'email', required: true },
            gender: { name: 'Gender', type: 'string' },
            birthDate: { name: 'Age', type: 'number' },
            jobTitle: { name: 'Job Title', type: 'string' },
            jobDescription: { name: 'Work Experience & Description', type: 'string' },
            education: { name: 'Academic & Professional Training', type: 'string' },
            skills: { name: 'Skills & Technologies', type: 'string' },
            workHistory: { name: 'Professional Experience', type: 'string' },
            achievement: { name: 'Project Experience (STAR)', type: 'string' },
            description: { name: 'Personality & Traits', type: 'string' },
            jobLookingFor: { name: 'Job Category', type: 'string' },
            jobLookingForType: { name: 'Job Type', type: 'string' },
            jobLookingForSalary: { name: 'Expected Salary', type: 'number' },
            jobLookingForLocation: { name: 'Interest', type: 'string' }
        }
    },
}; 